// extracted by mini-css-extract-plugin
export var bankIdVisible = "layout-module--bankIdVisible--06dbe";
export var fullscreenContainer = "layout-module--fullscreenContainer--a8e9b";
export var layoutContainer = "layout-module--layoutContainer--2ee2a";
export var newStyleMain = "layout-module--newStyleMain--4aa71";
export var noRelativePos = "layout-module--noRelativePos--0ebb6";
export var overflowVisible = "layout-module--overflowVisible--b30ba";
export var skipToContent = "layout-module--skipToContent--5ea45";
export var whiteBackground = "layout-module--whiteBackground--e8ec6";